import Swal from "sweetalert2";
import faradayApi from "../../api/faradayApi"

export const addPartner = async (formValues, firstMsg, secondMsg, errorMsg, mailExist, navigate) => {

    try {
        
        const {data} = await faradayApi.post('/user', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${firstMsg} ${data.individual.email} ${secondMsg}`,
                icon: "success",
            })
            navigate('/partners')
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
        if (error.response.data.msg === 'Este email ya está registrado' || error.response.data.msg.name === 'SequelizeUniqueConstraintError' ) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: mailExist,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        } else {
            Swal.fire({
                    confirmButtonColor: '#001B60',
                    text: errorMsg,
                    icon: "error",
                    iconColor: '#FF7765'
                })
            
                return false
        }
    }
}

export const deletePartner = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm ) => {
    const { value } = await Swal.fire({
        text: `${deleteConfirm} ${e.row.email}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
    })
    value && onConfirm(e.row.id, succesMsg, errorMsg , e.row.email)
}

const onConfirm = async (id, succesMsg, errorMsg, email) => {

    const { data } = await faradayApi.delete('/user', { data: { id } });

    data.data !== 0 && !data.error ?
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: `${email} ${succesMsg}`,
            icon: "success",
        })
        :
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
        })
}

export const editPartner = async (formValues, succesMsg, errorMsg, dupEmailMsg) => {

    try {

        const { data } = await faradayApi.put('/user/updateById', formValues)

        if (data.status === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${formValues.name} ${succesMsg}`,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
        if (error.response.data.error.original.code === 'ER_DUP_ENTRY'){
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: dupEmailMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
        return false
    }
}